export const getBondMonitorColumns = () => [
  {
    accessorKey: "Source_Sheet",
    header: "Source",
    size: 140, // increased size
    muiTableHeadCellProps: { align: "left" },
    muiTableBodyCellProps: { align: "left" },
  },
  {
    accessorKey: "Underlying",
    header: "Underlying",
    size: 140, // increased size
    muiTableHeadCellProps: { align: "left" },
    muiTableBodyCellProps: { align: "left" },
  },
  {
    accessorKey: "Target_Ticker",
    header: "Target Ticker",
    size: 160, // increased size for header
    muiTableHeadCellProps: {
      align: "left",
      style: { position: "sticky", left: 0, zIndex: 2 },
    },
    muiTableBodyCellProps: {
      align: "left",
      style: { position: "sticky", left: 0, zIndex: 1 },
    },
  },
  {
    accessorKey: "Strat",
    header: "Strategy",
    size: 140, // increased size
    muiTableHeadCellProps: { align: "left" },
    muiTableBodyCellProps: { align: "left" },
  },
  {
    accessorKey: "Workout_PX",
    header: "Workout Price",
    size: 140, // increased size
    muiTableHeadCellProps: { align: "right" },
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value ? Number(value).toFixed(3) : "-";
    },
  },
  {
    accessorKey: "Purch_Px_Model",
    header: "Purchase Price",
    size: 140, // increased size
    muiTableHeadCellProps: { align: "right" },
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value ? Number(value).toFixed(3) : "-";
    },
  },
  {
    accessorKey: "Closing_Date",
    header: "Closing Date",
    size: 140, // increased size
    muiTableHeadCellProps: { align: "right" },
    muiTableBodyCellProps: { align: "right" },
  },
  {
    accessorKey: "Gross_Spread",
    header: "Gross Spread",
    size: 140, // increased size
    muiTableHeadCellProps: { align: "right" },
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value ? Number(value).toFixed(3) : "-";
    },
  },
  {
    accessorKey: "Percent_Gross_Spread",
    header: "Gross Spread %",
    size: 150, // increased size
    muiTableHeadCellProps: { align: "right" },
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value ? `${(Number(value) * 100).toFixed(2)}%` : "-";
    },
  },
  {
    accessorKey: "Pre_Financing_IRR",
    header: "Pre-Financing IRR",
    size: 160, // increased size
    muiTableHeadCellProps: { align: "right" },
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value ? `${(Number(value) * 100).toFixed(2)}%` : "-";
    },
  },
  {
    accessorKey: "Net_Spread",
    header: "Net Spread",
    size: 140, // increased size
    muiTableHeadCellProps: { align: "right" },
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value ? Number(value).toFixed(3) : "-";
    },
  },
  {
    accessorKey: "Percent_Net_Spread",
    header: "Net Spread %",
    size: 140, // increased size
    muiTableHeadCellProps: { align: "right" },
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value ? `${(Number(value) * 100).toFixed(2)}%` : "-";
    },
  },
  {
    accessorKey: "NET_IRR",
    header: "Net IRR",
    size: 120, // can keep as is, header is short
    muiTableHeadCellProps: { align: "right" },
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value ? `${(Number(value) * 100).toFixed(2)}%` : "-";
    },
  },
  {
    accessorKey: "Downside",
    header: "Downside",
    size: 120, // can keep as is
    muiTableHeadCellProps: { align: "right" },
    muiTableBodyCellProps: { align: "right" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value ? Number(value).toFixed(3) : "-";
    },
  },
  {
    accessorKey: "ID_ISIN",
    header: "ISIN",
    size: 120, // can keep as is
    muiTableHeadCellProps: { align: "left" },
    muiTableBodyCellProps: { align: "left" },
  },
  {
    accessorKey: "ID_BB_GLOBAL",
    header: "BB Global",
    size: 130, // increased size
    muiTableHeadCellProps: { align: "left" },
    muiTableBodyCellProps: { align: "left" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value === "0" ? "-" : value;
    },
  },
  {
    accessorKey: "ID_CUSIP",
    header: "CUSIP",
    size: 120, // can keep as is
    muiTableHeadCellProps: { align: "left" },
    muiTableBodyCellProps: { align: "left" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value === "0" ? "-" : value;
    },
  },
  {
    accessorKey: "Full_Identifier",
    header: "Full Identifier",
    size: 150, // increased size
    muiTableHeadCellProps: { align: "left" },
    muiTableBodyCellProps: { align: "left" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value === "0" ? "-" : value;
    },
  },
  {
    accessorKey: "Identifier",
    header: "Identifier",
    size: 130, // increased size
    muiTableHeadCellProps: { align: "left" },
    muiTableBodyCellProps: { align: "left" },
    Cell: ({ cell }) => {
      const value = cell.getValue();
      return value === "0" ? "-" : value;
    },
  },
];
